import { Injectable } from '@angular/core';
import {
  BASE_API_URL,
  IListingSearchResponse,
  IPoiSearchResponse,
  ISearchAutocompleteRequest,
} from '@curbnturf/entities';
import { objectToUrlParams } from '@curbnturf/helpers';
import { CachedHttpClient } from '@curbnturf/network';

const API_URL = BASE_API_URL + 'search';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private http: CachedHttpClient) { }

  searchForPoi(query: ISearchAutocompleteRequest) {
    return this.http.get<IPoiSearchResponse>(`${API_URL}/poi?${objectToUrlParams(query)}`);
  }

  searchForPoiPrefix(query: ISearchAutocompleteRequest) {
    return this.http.get<IPoiSearchResponse>(`${API_URL}/poi-prefix?${objectToUrlParams(query)}`);
  }

  searchForPoiAutocomplete(query: ISearchAutocompleteRequest) {
    return this.http.get<IPoiSearchResponse>(
      `${API_URL}/poi-autocomplete?${objectToUrlParams(query)}`,
    );
  }

  searchForListingAutocomplete(query: ISearchAutocompleteRequest) {
    return this.http.get<IListingSearchResponse>(`${API_URL}/listing-autocomplete?${objectToUrlParams(query)}`);
  }

  poiIndexStatistics() {
    return this.http.get<{ count: number; }>(`${API_URL}/poi/stats`);
  }

  listingIndexStatistics() {
    return this.http.get<{ count: number; }>(`${API_URL}/listing/stats`);
  }

  recreateIndexes() {
    return this.http.delete<{ success: boolean; }>(`${API_URL}/indexes/recreate`);
  }
}
